import { useMemo } from 'react';
import { useGetTravellersPerOrganization } from '@/api/trafikportalen';
import {
  findTravellerDuplicates,
  type DuplicateSearchFields,
} from '@/helpers/travellerDuplicates';

export type { DuplicateMatch } from '@/helpers/travellerDuplicates';

interface UseTravellerDuplicateDetectionResult {
  duplicates: ReturnType<typeof findTravellerDuplicates>;
  isLoading: boolean;
  hasMatches: boolean;
}

export const useTravellerDuplicateDetection = (
  searchFields: DuplicateSearchFields,
): UseTravellerDuplicateDetectionResult => {
  const { data: travellers, isLoading } = useGetTravellersPerOrganization();

  const duplicates = useMemo(
    () => findTravellerDuplicates(travellers, searchFields),
    [travellers, searchFields],
  );

  return {
    duplicates,
    isLoading,
    hasMatches: duplicates.length > 0,
  };
};
